import {
  ActionArm,
  ActionDisarm,
  ActionElevate,
  ActionGoto,
  ActionGripper,
  ActionLand,
  ActionSetServo,
  ActionStickControl,
  ActionTakeoff,
  CameraGimbal,
  CameraLiveView,
  CameraShoot,
  CameraSetAutoShoot,
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
  ModeAltHold,
  ModeAuto,
  ModeBrake,
  ModeGuided,
  ModeLoiter,
  ModePosHold,
  ModeRTL,
  ModeStabilize,
} from '@/define/commandSet/mavlink';

const operation = [
  {
    name: 'Mode',
    commands: [ModeGuided, ModeStabilize, ModeAuto, ModeLoiter, ModeBrake, ModeAltHold, ModePosHold, ModeRTL],
  },
  {
    name: 'Action',
    commands: [
      ActionArm,
      ActionDisarm,
      ActionTakeoff,
      ActionGoto,
      ActionElevate,
      ActionLand,
      ActionStickControl,
      ActionGripper,
      ActionSetServo,
    ],
  },
  {
    name: 'Camera',
    commands: [CameraLiveView, CameraGimbal, CameraShoot, CameraSetAutoShoot],
  },
  {
    name: 'Mission',
    commands: [MissionLoad, MissionUpload, MissionStart, MissionResume, MissionClear],
  },
];

export default operation;
